/**
 * 设备类型
 */

function DeviceType() {}

DeviceType.install = function (Vue) {
  let deviceType = {};
  deviceType.ios = false;
  deviceType.android = false;
  deviceType.pc = false;
  deviceType.ios = false;
  deviceType.wx = false;
  deviceType.app = false;
  deviceType.spider = false;

  let cookie = "", ua = "";

  if (window && window.navigator) {
    ua = window.navigator.userAgent;
  }
  if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
    deviceType.ios = true;
  } else if (/(Android)/i.test(ua)) {
    deviceType.android = true;
  } else {
    deviceType.pc = true;
  }

  if (document) {
    cookie = document.cookie;
  }

  /** 判断是不是 微信 **/
  if (/(MicroMessenger)/i.test(ua)) {
    deviceType.wx = true;
  }

  deviceType.isMobile = function() {
    return deviceType.ios || deviceType.android;
  };

  deviceType.isPC = function() {
    return deviceType.pc;
  };

  deviceType.isWx = function() {
    return deviceType.wx;
  };
  // console.log('当前配置：', config)
  Vue.prototype.$deviceType = deviceType
}

export default DeviceType